<template>
  <LayoutManager
    :mode="layoutMode"
    :layout-data="layoutData"
    :stallholder-data="stallholderData"
  />
</template>

<script>
import LayoutManager from "@/components/layouts/LayoutManager.vue";

export default {
  name: "LayoutConfiguration",

  components: {
    LayoutManager,
  },

  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    layoutData: {
      type: Object,
      default: null,
    },
    stallholderData: {
      type: Object,
      default: null,
    },
  },

  computed: {
    layoutMode() {
      // Determine mode based on route parameter
      return this.$route.params.id === "create" ? "create" : "update";
    },
  },
};
</script>
